var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoneyPointsYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 393,
    viewBox: "0 0 407 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.857 172.536L114.857 171.381L112.857 172.536L23.7802 223.964L21.7802 225.119V227.429V330.286V332.595L23.7802 333.75L112.857 385.178L114.857 386.333L116.857 385.178L205.934 333.75L207.934 332.595V330.286V227.429V225.119L205.934 223.964L116.857 172.536Z",
    fill: "white",
    stroke: "#FBD300",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.857 174.536L295.857 173.381L293.857 174.536L204.78 225.964L202.78 227.119V229.429V332.286V334.595L204.78 335.75L293.857 387.178L295.857 388.333L297.857 387.178L386.934 335.75L388.934 334.595V332.286V229.429V227.119L386.934 225.964L297.857 174.536Z",
    fill: "white",
    stroke: "#FBD300",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.857 15.5359L203.857 14.3812L201.857 15.5359L112.78 66.9644L110.78 68.1191V70.4285V173.286V175.595L112.78 176.75L201.857 228.178L203.857 229.333L205.857 228.178L294.934 176.75L296.934 175.595V173.286V70.4285V68.1191L294.934 66.9644L205.857 15.5359Z",
    fill: "white",
    stroke: "#FBD300",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoneyPointsYellow);
export default __webpack_public_path__ + "static/media/honeyPointsYellow.dd3f21fc096dc9d29e462b84d7acf8e4.svg";
export { ForwardRef as ReactComponent };